
/**
 * Inicijalizira podatke za autentikaciju u localStorage za statički način rada
 * bez potrebe za prijavom korisnika
 */
export const initStaticAuth = () => {
  // Provjeri postoji li već autentifikacija
  const existingAuth = localStorage.getItem("7gc_auth");
  if (!existingAuth) {
    // Ako ne postoji, kreiraj statičku autentifikaciju
    const staticAuth = {
      isAuthorized: true,
      username: "static-user",
      timestamp: new Date().getTime()
    };
    // Spremi u localStorage
    localStorage.setItem("7gc_auth", JSON.stringify(staticAuth));
    console.log("Statička autentifikacija inicijalizirana");
  }
};
